module.exports = __webpack_public_path__ + "img/BSC_drawer45cc_white.83a6388e.png";